"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOT_FOUND = exports.DISCONTINUED = exports.DIALOG_MODE_STANDARD_BUY = exports.DIALOG_MODE_LOADING = exports.DIALOG_MODE_FAVORITES = void 0;
const DIALOG_MODE_FAVORITES = exports.DIALOG_MODE_FAVORITES = 'favorites';
const DIALOG_MODE_LOADING = exports.DIALOG_MODE_LOADING = 'loading';
const DIALOG_MODE_STANDARD_BUY = exports.DIALOG_MODE_STANDARD_BUY = 'standardBuy';
const DISCONTINUED = exports.DISCONTINUED = 'discontinued';
const NOT_FOUND = exports.NOT_FOUND = 'notFound';